import {Modal} from "../components/modal/modal";
import React, {ReactNode} from "react";
export const createModal = (children: ReactNode, func?: () => void) => <Modal closeModal={func}>{children}</Modal>;